export default class Srv {
  
  // hasBase means the srv is already in the api and child( 'srv' ) 
  // should be avoided
  constructor( api, alias, hasBase = false ) {
    this.api = api
    this.connect = hasBase !== true ?
      api.child( 'srv' ).child( alias ) :
      api.child( alias )
  }

  get( cmd, data, options ) {
    return this.connect.child( cmd ).get( data, options )
  }

  post( cmd, body, query, options ) {
    return this.connect.child( cmd ).post( body, query, options )
  }

  put( cmd, body, query, options ) {
    return this.connect.child( cmd ).put( body, query, options )
  }

  patch( cmd, body, query, options ) {
    return this.connect.child( cmd ).patchRaw( body, query, options )
  }

  delete( cmd, body, query, options ) {
    return this.connect.child( cmd ).delete( body, query, options )
  }

}
